<fc-general-modal
  [baseId]="baseId"
  [mode]="mode"
  [isSaveDisabled]="!selectedPersonPks.length"
  [form]="form"
  [listItemName]="listItemName"
  (saveForm)="onSave()"
  (cancelForm)="onCancel()"
>
  <div class="copy-contact-info" [formGroup]="form">
    <div class="form-group full-control">
      <h4 translate>Copy from</h4>
      <ap-findcontrol
        id="{{ baseId }}-person"
        controlName="personUid"
        findControlDisplayName="Find Person"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [singleSelect]="true"
        (chipsChange)="onPersonDataPopulate($event)"
        [findControlId]="'ViewFindPerson'"
        [selectedPks]="selectedPersonPks"
        (dirty)="personControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <div class="form-group contact">
      <h4 translate>Contact Items to Copy</h4>
      <div class="checkbox-group">
        <mat-checkbox
          id="{{ baseId }}-addresses"
          formControlName="addresses"
          translate
        >Addresses
        </mat-checkbox>
        <mat-checkbox
          id="{{ baseId }}-phone-numbers"
          formControlName="phoneNumbers"
          translate
        >Phone Numbers
        </mat-checkbox>
        <mat-checkbox
          id="{{ baseId }}-emailAddresses"
          formControlName="emailAddresses"
          translate
        >Email Addresses
        </mat-checkbox>
      </div>
    </div>
  </div>
</fc-general-modal>
